export default __webpack_public_path__ + "static/media/ai72-2.fd185955.jpg";